



































import { Component, Mixins, Prop } from "vue-property-decorator";
import mixins from "../mixins";
@Component
export default class FitCheckbox extends Mixins(mixins) {
  @Prop({ default: "#07C160" }) public fill;
  @Prop({ default: 60 }) public size;
}
